// BTCGiftCardVsATMSection.jsx — v3 STATIC REBUILD — real photos, zero animation
import React from 'react';

const BTCGiftCardVsATMSection = ({ onGetStarted }) => (
  <section style={{ background:'#ffffff', padding:'80px 16px' }}>
    <div style={{ maxWidth:'1100px', margin:'0 auto' }}>

      {/* Label */}
      <p style={{ textAlign:'center', color:'#f97316', fontWeight:700,
        textTransform:'uppercase', letterSpacing:'3px', fontSize:'13px', marginBottom:'16px' }}>
        ₿ The Bitcoin Revolution Is Here
      </p>

      {/* Headlines */}
      <h2 style={{ textAlign:'center', fontSize:'clamp(36px,6vw,64px)',
        fontWeight:900, color:'#111827', lineHeight:1.1, marginBottom:'8px' }}>
        Forget the ATM.
      </h2>
      <h3 style={{ textAlign:'center', fontSize:'clamp(28px,5vw,52px)',
        fontWeight:900, color:'#f97316', lineHeight:1.1, marginBottom:'28px' }}>
        Bitcoin Is Now At Your Favorite Store.
      </h3>

      {/* Body copy */}
      <p style={{ textAlign:'center', color:'#4b5563', fontSize:'18px',
        maxWidth:'680px', margin:'0 auto 64px', lineHeight:1.7 }}>
        Bitcoin ATMs charge up to <strong style={{color:'#ef4444'}}>15% in fees</strong> and
        there are fewer than <strong style={{color:'#ef4444'}}>14,000 of them</strong> in the
        entire USA. Our BTC Gift Cards are available at{' '}
        <strong style={{color:'#16a34a'}}>200,000+ stores</strong> — and online —
        with zero hidden fees.
      </p>

      {/* 3-column visual comparison */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr',
        gap:'32px', alignItems:'center', maxWidth:'900px', margin:'0 auto 64px' }}>

        {/* LEFT — real ATM photo with X */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
          <div style={{ position:'relative', borderRadius:'24px', overflow:'hidden',
            border:'4px solid #fca5a5', boxShadow:'0 8px 32px rgba(0,0,0,0.12)' }}>
            <img src="/btc-atm-machines.png" alt="Bitcoin ATMs"
              style={{ width:'100%', display:'block',
                filter:'brightness(1)' }} />
            {/* Red X overlay */}
            <div style={{ position:'absolute', inset:0,
              display:'flex', alignItems:'center', justifyContent:'center' }}>
              <div style={{ position:'relative', width:'160px', height:'160px' }}>
                <div style={{ position:'absolute', inset:0, borderRadius:'50%',
                  border:'8px solid #dc2626',
                  boxShadow:'0 0 0 3px rgba(220,38,38,0.3), inset 0 0 30px rgba(220,38,38,0.2)' }} />
                <div style={{ position:'absolute', top:'50%', left:'50%',
                  width:'130px', height:'20px', background:'#dc2626', borderRadius:'10px',
                  transform:'translate(-50%,-50%) rotate(45deg)',
                  boxShadow:'0 4px 20px rgba(220,38,38,0.8)' }} />
                <div style={{ position:'absolute', top:'50%', left:'50%',
                  width:'130px', height:'20px', background:'#dc2626', borderRadius:'10px',
                  transform:'translate(-50%,-50%) rotate(-45deg)',
                  boxShadow:'0 4px 20px rgba(220,38,38,0.8)' }} />
              </div>
            </div>
            <div style={{ position:'absolute', inset:0, background:'rgba(255,255,255,0)' }} />
          </div>
          {/* ATM label */}
          <div style={{ marginTop:'16px', background:'#fef2f2', border:'2px solid #fca5a5',
            borderRadius:'16px', padding:'12px 20px', textAlign:'center', width:'100%' }}>
            <div style={{ fontWeight:700, color:'#dc2626', marginBottom:'4px' }}>Bitcoin ATM</div>
            <div style={{ color:'#6b7280', fontSize:'12px' }}>Under 14,000 USA locations</div>
            <div style={{ color:'#ef4444', fontSize:'12px', fontWeight:600 }}>Up to 15% fees · Hard to locate</div>
          </div>
        </div>

        {/* CENTER — VS */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'12px' }}>
          <div style={{ width:'64px', height:'64px', background:'#7c3aed', borderRadius:'50%',
            display:'flex', alignItems:'center', justifyContent:'center',
            boxShadow:'0 4px 20px rgba(124,58,237,0.4)' }}>
            <span style={{ color:'white', fontWeight:900, fontSize:'18px' }}>VS</span>
          </div>
          <span style={{ color:'#d1d5db', fontSize:'28px' }}>→</span>
        </div>

        {/* RIGHT — lady with card */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
          <div style={{ position:'relative', borderRadius:'24px', overflow:'hidden',
            border:'4px solid #86efac', boxShadow:'0 8px 32px rgba(0,0,0,0.12)' }}>
            <img src="/lady-with-card.jpg" alt="Happy shopper with Zanors BTC Gift Card"
              style={{ width:'100%', display:'block', objectFit:'cover',
                objectPosition:'top', maxHeight:'280px' }} />
            {/* Verified badge */}
            <div style={{ position:'absolute', top:'12px', right:'12px',
              width:'36px', height:'36px', background:'#16a34a', borderRadius:'50%',
              border:'3px solid white', display:'flex', alignItems:'center',
              justifyContent:'center', boxShadow:'0 2px 8px rgba(0,0,0,0.3)' }}>
              <svg width="18" height="18" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            {/* Card overlay */}
            <div style={{ position:'absolute', bottom:0, left:0, right:0, padding:'10px' }}>
              <div style={{ background:'linear-gradient(135deg,#78350f,#1c1917)',
                borderRadius:'12px', padding:'12px',
                border:'1px solid rgba(234,179,8,0.3)',
                boxShadow:'0 4px 20px rgba(0,0,0,0.5)' }}>
                <div style={{ display:'flex', justifyContent:'space-between',
                  alignItems:'flex-start', marginBottom:'4px' }}>
                  <div>
                    <div style={{ color:'#fbbf24', fontWeight:800, fontSize:'11px',
                      letterSpacing:'2px' }}>ZANORS</div>
                    <div style={{ color:'rgba(251,191,36,0.5)', fontSize:'9px' }}>BITCOIN GIFT CARD</div>
                  </div>
                  <div style={{ width:'28px', height:'28px', background:'#f97316',
                    borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <span style={{ color:'white', fontSize:'13px', fontWeight:700 }}>₿</span>
                  </div>
                </div>
                <div style={{ color:'white', fontWeight:900, fontSize:'22px', marginBottom:'2px' }}>$100</div>
                <div style={{ color:'#6b7280', fontSize:'10px', letterSpacing:'3px' }}>•••• •••• •••• 4821</div>
              </div>
            </div>
          </div>
          {/* Zanors label */}
          <div style={{ marginTop:'16px', background:'#f0fdf4', border:'2px solid #86efac',
            borderRadius:'16px', padding:'12px 20px', textAlign:'center', width:'100%' }}>
            <div style={{ fontWeight:700, color:'#15803d', marginBottom:'4px' }}>Zanors BTC Gift Card ✦</div>
            <div style={{ color:'#6b7280', fontSize:'12px' }}>200,000+ stores across USA</div>
            <div style={{ color:'#16a34a', fontSize:'12px', fontWeight:600 }}>Zero fees · Instant · Online &amp; In-Store</div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)',
        gap:'20px', maxWidth:'860px', margin:'0 auto 48px' }}>
        {[
          { stat:'200,000+', label:'Store locations',  sub:'vs under 14,000 ATMs',    c:'#15803d', bg:'#f0fdf4', border:'#86efac' },
          { stat:'0%',       label:'Hidden fees',      sub:'vs up to 15% at ATMs',    c:'#1d4ed8', bg:'#eff6ff', border:'#93c5fd' },
          { stat:'< 60s',    label:'To get your BTC',  sub:'vs searching for an ATM', c:'#6d28d9', bg:'#f5f3ff', border:'#c4b5fd' },
        ].map(({ stat, label, sub, c, bg, border }) => (
          <div key={label} style={{ background:bg, border:`2px solid ${border}`,
            borderRadius:'20px', padding:'24px', textAlign:'center' }}>
            <div style={{ fontSize:'40px', fontWeight:900, color:c, lineHeight:1 }}>{stat}</div>
            <div style={{ fontWeight:700, color:'#111827', margin:'6px 0 2px', fontSize:'15px' }}>{label}</div>
            <div style={{ color:'#9ca3af', fontSize:'12px' }}>{sub}</div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ textAlign:'center' }}>
        <button onClick={onGetStarted}
          style={{ background:'#f97316', color:'white', fontWeight:700,
            padding:'16px 40px', borderRadius:'16px', fontSize:'18px', border:'none',
            cursor:'pointer', boxShadow:'0 4px 20px rgba(249,115,22,0.4)',
            display:'inline-flex', alignItems:'center', gap:'8px' }}>
          Get Your BTC Gift Card
          <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3"/>
          </svg>
        </button>
        <p style={{ color:'#9ca3af', fontSize:'14px', marginTop:'12px' }}>
          Instant delivery · 200,000+ stores · No hidden fees
        </p>
      </div>

    </div>
  </section>
);

export default BTCGiftCardVsATMSection;